<template>
  <div class="modal-confirmation">
    <div class="d-flex justify-content-center flex-column align-items-center py-4">
      <img
        width="170"
        height="170"
        src="@/assets/icon/confirmation.svg"
        alt="icon popup confirmation"
        class="mb-4"
      >
      <p class="title">Confirmation</p>
      <p
        class="message"
        v-html="message"
      />
      <div class="w-full d-flex justify-content-center">
        <button
          class="button-border-blue mr-4"
          @click="$emit('close')"
        >
          Cancel
        </button>
        <button
          class="button-blue"
          @click="$emit('confirm')"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/popup/jPopupConfirmation.vue